import { Component, OnInit, inject } from '@angular/core'
import { Router, RouterLink } from '@angular/router'
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap'

import {
  CompanyContextService,
  UserCompany,
} from '@/app/services/http/company-context.service'

@Component({
  selector: 'app-org-switcher',
  standalone: true,
  imports: [NgbDropdownModule, RouterLink],
  templateUrl: './org-switcher.component.html',
  styles: ``,
})
export class OrgSwitcherComponent implements OnInit {
  companies: UserCompany[] = []

  private companyContext = inject(CompanyContextService)
  private router = inject(Router)

  get activeCompanyId(): number | null {
    return this.companyContext.activeCompanyId
  }

  get activeCompany(): UserCompany | undefined {
    return this.companies.find((c) => c.id === this.activeCompanyId)
  }

  ngOnInit(): void {
    this.companyContext.getCompanies().subscribe((companies) => {
      this.companies = companies
    })
  }

  initials(name: string): string {
    return name
      .split(' ')
      .slice(0, 2)
      .map((w) => w[0])
      .join('')
      .toUpperCase()
  }

  selectCompany(companyId: number): void {
    this.companyContext.selectCompany(companyId)
    this.router.navigate(['/dashboard/analytics'])
  }
}
